module.exports = __webpack_public_path__ + "static/img/三维制作画面4.6e37c537.png";